import React, { useEffect, useState, forwardRef, useRef } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import DatePicker from 'react-datepicker'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, RootState } from '@/store';
import { createSchedule, getScheduleDetail, updateSchedule } from '@/store/schedule/detail/action';
import { getCalendar } from '@/store/calendar/action';
import { getUserVenues } from '@/store/user-info/action';
import { getVenueDetail } from '@/store/venue-detail/action';
import HeaderLayout from "@/components/common/CustomLayout/HeaderLayout";
import { ReactComponent as RiArrowLeft } from '@/assets/icons/arrow-left.svg'
import { ReactComponent as RiArrowRight } from '@/assets/icons/arrow-right.svg'
import Input from '@/components/common/Input';
import Calendar from '@/components/common/Calendar';
import Summary from '@/pages/ClosedSchedule/Form/Summary';
import Button from "@/components/common/Button";
import { convertLocalToWita } from '@/utils';
import 'react-datepicker/dist/react-datepicker.css'
import UserVenueSelect from "@/components/common/UserVenueSelect";
import { openingHours } from '@/utils/validation';
import LogInfo from './LogInfo';

const OPENING_HOURS = openingHours;

const dateUpdate = (operator: string, startDate: number) => {
	let newStart = startDate
	if (operator === 'prev') {
		newStart += -7 * 24 * 60 * 60 * 1000
	} else if (operator === 'next') {
		newStart += 7 * 24 * 60 * 60 * 1000
	}
	return {
		newStart: new Date(newStart).getTime(),
		newEnd: new Date(newStart + 6 * 24 * 60 * 60 * 1000).getTime()
	}
}
const handleSubmit = async (
	selectedSchedules: ScheduleList,
	venueDetail: Venue,
	{ nameMethods }: any,
	dispatch: Function,
	navigate: Function,
	scheduleId: string) => {
	const details = Object.entries(selectedSchedules).map((schedule: {}) => schedule[1].map(bookingDetail => {
			const { court, hour, selectedDate } = bookingDetail
			return {
				venue_court_id: court.id,
				start_time: hour,
				end_time: hour+1,
				date: selectedDate
			}
		})
	)
	const payload = {
		reason: nameMethods.getValues('closingReason'),
		venue_id: venueDetail.id,
		details: details.flat()
	}
	if (scheduleId) {
		await dispatch(updateSchedule({ id: scheduleId, data: payload })).then((res) => {
			if (!res.error) {
				navigate('/dashboard/calendar/closed-schedule')
			}
		})
	}
	else {
		await dispatch(createSchedule(payload)).then((res) => {
			if (!res.error) {
				navigate('/dashboard/calendar/closed-schedule')
			}
		})
	}
}

const ShowCalendar = forwardRef<any>((
	{ value, onClick }: { value: string, onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void },
	ref) => (
	<Button variant="basic"
					type="button"
					className="border border-grey-line-subtle"
					onClick={onClick} ref={ref}>
		{value}
	</Button>))

const ClosedScheduleForm = () => {
	const [selectedDate, setSelectedDate] = useState(convertLocalToWita(new Date().setHours(0,0,0,0)))
	const [startDate, setStartDate] = useState(new Date().setDate(new Date().getDate() - (new Date().getDay() + 6) % 7))
	const [endDate, setEndDate] = useState(new Date().setDate(new Date(startDate).getDate() + 6))
	const [selectedSchedules, setSelectedSchedules] = useState({})
	const [conflictingSchedules, setConflictingSchedules] = useState([])
	const [selectedVenue, setSelectedVenue] = useState(null)
	const [bookingByCourt, setBookingByCourt] = useState([])
	const venueState = useSelector((state: RootState) => state.userInfo.state.venues)
	const venueDetailState = useSelector((state: RootState) => state.venueDetail.venue)
	const { state: calendarItems, loading: calendarLoading } = useSelector((state: RootState) =>  state.calendar)
	const { state: bookedSchedules, loading: scheduleLoading } = useSelector((state: RootState) =>  state.schedule)
	const { scheduleId } = useParams()
	const nameMethods = useForm()
	const inputRef = useRef(null)
	const dispatch = useAppDispatch()
	const navigate = useNavigate()
	const [created_at, setCreatedAt] = useState<Date | null>(null);
	const [updated_at, setUpdatedAt] = useState<Date | null>(null);


	useEffect(() => {
		(async () => {
			await dispatch(getUserVenues({}))
		})()
	}, [])
	useEffect(() => {
		if (scheduleId) {
			const setScheduleDetailForm = (scheduleState: ScheduleDetailState) => {
				const scheduleList = {}
				const bookingList = []
				setCreatedAt(new Date(scheduleState.created_at))
				setUpdatedAt(new Date(scheduleState.updated_at))
				setSelectedVenue(scheduleState.venue_id)
				nameMethods.setValue('venueId', scheduleState.venue_id);
				nameMethods.setValue('venueName', scheduleState.venue?.name);
				nameMethods.setValue('closingReason', scheduleState.reason)
				scheduleState.details?.forEach(schedule => {
					const scheduleDetail = {
						court: {
							id: schedule.venue_court_id,
							name: schedule.venue_court?.code
						},
						hour: schedule.start_time,
						selectedDate: schedule.date
					}
					if (scheduleList[schedule.date]) {
						scheduleList[schedule.date].push(scheduleDetail)
					} else {
						scheduleList[schedule.date] = [{ ...scheduleDetail }]
					}

					if (bookingList[schedule.date]) {
						bookingList[schedule.date].push({
							hour: schedule.start_time,
							type: 'BOOKING',
							detail: bookedSchedules.reason,
							id: schedule.venue_court_id
						})
					}
					else {
						bookingList[schedule.date] = [{
							hour: schedule.start_time,
							type: 'BOOKING',
							detail: bookedSchedules.reason
						}]
					}
				})
				Object.keys(bookingList).forEach(bookingDate => {
					bookingList[bookingDate].forEach(scheduleDetail => {
						scheduleList[bookingDate].forEach((court, idx) => {
							if (court.id === bookingList[bookingDate].id) {
								const newSchedule = {
									hour: scheduleDetail.hour,
									type: scheduleDetail.type,
									detail: scheduleDetail.detail
								}
								if (scheduleList[bookingDate][idx].court.schedules) {
									scheduleList[bookingDate][idx].court.schedules.push(newSchedule)
								} else {
									scheduleList[bookingDate][idx].court.schedules = [{...newSchedule}]
								}
							}
						})
					})
				})
				setSelectedSchedules(scheduleList)
				setSelectedDate(scheduleState.details[0].date)
				setStartDate(new Date(scheduleState.details[0].date).setDate(new Date(scheduleState.details[0].date).getDate() - (new Date(scheduleState.details[0].date).getDay() + 6) % 7))
				setEndDate(new Date(startDate).setDate(new Date(startDate).getDate() + 6))
			}
			dispatch(getScheduleDetail({ id: scheduleId, success: setScheduleDetailForm }))
		} else {
			setSelectedVenue(null)
			nameMethods.reset({})
		}
	}, [scheduleId])
	useEffect(() => {
		(async () => {
			if (!selectedVenue) { return }
			await dispatch(getVenueDetail(selectedVenue))
		})()
	}, [selectedVenue])
	useEffect(() => {
		const fetchCalendarItems = async () => {
			await dispatch(getCalendar({
				dateMeta: selectedDate,
				venueMeta: selectedVenue
			}))
		}
		fetchCalendarItems()
	}, [venueDetailState, selectedDate])
	useEffect(() => {
		setBookingByCourt([])
		const bookings = []
		calendarItems.forEach(calendarItem => {
			const schedules = calendarItem.items?.filter(item => item.event_id !== scheduleId)?.map(item => (
				{
					hour: item.start_time || 0,
					type: item.event_type || '',
					detail: item.description || ''
				}
			))
			bookings.push({
				code: calendarItem.court_code,
				id: calendarItem.court_id,
				schedules
			})
		})
		setBookingByCourt(bookings)
	}, [calendarItems])

	return (
		<div>
			<HeaderLayout
				title={scheduleId ? 'Edit Schedule' : 'Add Schedule'}
				rightComponent={
					<Button
						type="submit"
						variant="primary"
						className="whitespace-nowrap flex gap-2 px-12 py-2 justify-center items-center text-jsm font-medium"
						form="closedScheduleForm"
						onClick={() => {nameMethods.handleSubmit(() => handleSubmit(selectedSchedules, venueDetailState, { nameMethods }, dispatch, navigate, scheduleId))}}
					>
						{scheduleId ? 'Update' : 'Add Schedule'}
					</Button>}
			>
				<div className='flex items-start gap-6'>
					<div className='flex flex-col basis-9/12 items-start gap-6'>
						<FormProvider {...nameMethods}>
							<div className='flex items-start w-full h-24 bg-white p-0'>
								<form className='flex items-start w-full h-24 bg-white p-0'
											id='closedScheduleForm'
											onSubmit={nameMethods.handleSubmit(() => handleSubmit(selectedSchedules, venueDetailState, { nameMethods }, dispatch, navigate, scheduleId))}>
									<Input name='closingReason'
												 type='text'
												 placeholder='Enter a reason for closing...'
												 className='text-3xl font-bold w-full h-full m-0 p-0 border-0 focus:outline-none'
												 {...nameMethods.register('closingReason', { required: 'Enter a reason for closing' })}
									/>
								</form>
							</div>
							<div className='flex flex-col w-full bg-white'>
								<div className='flex justify-between items-center w-full py-6 px-8 gap-12'>
									<Controller
										name='selectedVenue'
										control={nameMethods.control}
										render={({ field }) =>
											<UserVenueSelect
												{...field}
												options={
													venueState.map(venue => ({
														label: venue.name,
														value: venue.id,
													}))
												}
												placeholder='Select venue'
												onChange={(val) => {
													setSelectedVenue(val.value);
													nameMethods.setValue('venueId', val?.value);
													nameMethods.setValue('venueName', val?.label);
												}}
												value={{
													value: nameMethods.watch('venueId'),
													label: nameMethods.watch('venueName') || 'Select venue',
												}}
											/>
										} />
									<div className='flex gap-2'>
										<Button variant='basic'
														type='button'
														className='border border-grey-line-subtle'
														onClick={() => {
															const newDates = dateUpdate('', new Date().getTime());
															setStartDate(newDates.newStart);
															setEndDate(newDates.newEnd);
														}}>
											Today
										</Button>
										<Button variant='basic'
														type='button'
														className='border border-grey-line-subtle'
														onClick={() => {
															const newDates = dateUpdate('prev', startDate);
															setStartDate(newDates.newStart);
															setEndDate(newDates.newEnd);
														}}><RiArrowLeft /></Button>
										<DatePicker
											selectsRange
											startDate={startDate}
											endDate={endDate}
											onChange={(date) => {
												const { newStart, newEnd } = dateUpdate('', date[0].getTime());
												setStartDate(newStart);
												setEndDate(newEnd);
											}}
											customInput={<ShowCalendar ref={inputRef} />}
										/>
										<Button variant='basic'
														type='button'
														className='border border-grey-line-subtle'
														onClick={() => {
															const newDates = dateUpdate('next', startDate);
															setStartDate(newDates.newStart);
															setEndDate(newDates.newEnd);
														}}><RiArrowRight /></Button>
									</div>
								</div>
								{selectedVenue && !calendarLoading && (scheduleId ? !scheduleLoading : true) &&
								<Calendar startDate={startDate}
													selectedDate={selectedDate}
													setSelectedDate={setSelectedDate}
													hours={OPENING_HOURS}
													courts={venueDetailState?.courts || []}
													bookingByCourt={bookingByCourt}
													selectedSchedules={selectedSchedules}
													setSelectedSchedules={setSelectedSchedules}
													conflictingSchedules={conflictingSchedules}
													setConflictingSchedules={setConflictingSchedules}
													displayCheckbox
								/>}
							</div>
						</FormProvider>
					</div>
					<div className='flex flex-col basis-3/12'>
						<Summary 
							selectedSchedules={selectedSchedules}
							conflictingSchedules={conflictingSchedules}
						/>

						
						{scheduleId && (
							<LogInfo 
								createdAt={created_at}
								updatedAt={updated_at}
							/>
						)}
					</div>
				</div>
			</HeaderLayout>
		</div>
)
}

export default ClosedScheduleForm
